// @core/api/endpoints/project/update_saved_view.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SavedViewResponse,
  UpdateSavedViewRequest,
} from '../../../types/project';

const BASE_PATH = '/project';

/**
 * Update saved view
 * Updates a saved view's filters, sorting, grouping, or display settings.
 */
export async function UpdateSavedView(
  project_id: string,
  view_id: string,
  data: UpdateSavedViewRequest,
  options?: RequestOptions
): Promise<SavedViewResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/views/:view_id`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  requestPath = requestPath.replace(':view_id', encodeURIComponent(view_id));
  const requestOptions = options;
  return client.put<SavedViewResponse>(requestPath, data, requestOptions);
}
